import { render, staticRenderFns } from "./yddzqdkhfwxy.vue?vue&type=template&id=50cbf50e&scoped=true"
import script from "./yddzqdkhfwxy.vue?vue&type=script&lang=js"
export * from "./yddzqdkhfwxy.vue?vue&type=script&lang=js"
import style0 from "./yddzqdkhfwxy.vue?vue&type=style&index=0&id=50cbf50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cbf50e",
  null
  
)

export default component.exports